import {LeagueRestriction} from "./LeagueRestriction";

export class GenderLeagueRestriction extends LeagueRestriction {

    /**
     * Returns the gender that is checked against
     * @returns {string}
     */
    public getGender(): string {
        return this.apiData.params.gender;
    }
}